module.exports = __webpack_public_path__ + "img/07.9e57ffd9.png";